<template>
    <div class="grouped-invoice-view">
      <!-- Top bar -->
      <div class="nav-bar-operations">
        <img src="@/assets/logogruas.png" alt="HomePage" @click="backMainPanel" class="logo-button" />
      </div>
      <div class="top-spacer"></div>
  
      <!-- Header -->
      <div class="panel-head">
        <h3>Creación de factura agrupada</h3>
        <img src="@/assets/filtros.png" alt="filtros" class="head-icon" />
      </div>
  
      <!-- Filters -->
      <form class="filters-card" @submit.prevent="queryOrders">
        <div class="row">
          <label for="orderNumber">Número de orden</label>
          <input type="text" id="orderNumber" v-model="noteIdent" placeholder="Inicio" />
          <span class="sep">al</span>
          <input type="text" id="orderNumberEnd" v-model="noteIdentEnd" placeholder="Fin" />
        </div>
  
        <div class="row">
          <label>Rango de fechas</label>
          <input type="date" v-model="startDate" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }" />
          <span class="sep">al</span>
          <input type="date" v-model="endDate" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }" />
        </div>
  
        <!-- Cliente (con sugerencias) -->
        <div class="row row-rel">
          <label for="client_name">Cliente</label>
          <input
            id="client_name"
            type="text"
            v-model="clientName"
            placeholder="Escriba para buscar"
            @input="filterSuggestions"
            autocomplete="off"
          />
          <div class="cell span-2"></div>
          <ul v-if="filteredClients.length" class="suggestions">
            <li v-for="(client, index) in filteredClients" :key="index" @click="selectClient(client)">
              {{ client.client_ident + ' - ' + client.client_name }}
            </li>
          </ul>
        </div>
  
        <div class="row">
          <label for="origin">Origen</label>
          <input type="text" id="origin" v-model="origin" placeholder="Origen" />
          <div class="cell span-2"></div>
        </div>
  
        <div class="row">
          <label for="note_type">Tipo de servicio</label>
          <select id="note_type" v-model="noteType" class="form-select">
            <option value="" disabled selected>Seleccione un tipo de servicio</option>
            <option :value="2">Remolque</option>
            <option :value="1">Auxilio vial</option>
            <option :value="4">Lote</option>
            <option :value="3">Montacargas</option>
            <option :value="5">Industrial</option>
          </select>
          <div class="cell span-2"></div>
        </div>
  
        <div class="row">
          <label for="destination">Destino</label>
          <input type="text" id="destination" v-model="destination" placeholder="Destino" />
          <div class="cell span-2"></div>
        </div>
  
        <div class="row">
          <label for="unit">Unidad</label>
          <input type="text" id="unit" v-model="unit" placeholder="Unidad" />
          <div class="cell span-2"></div>
        </div>
  
        <div class="row">
          <label for="operator">Operador</label>
          <input type="text" id="operator" v-model="operator" placeholder="Operador" />
          <div class="cell span-2"></div>
        </div>
  
        <div class="row">
          <label for="file">Expediente</label>
          <input type="text" id="file" v-model="file" placeholder="Expediente" />
          <div class="cell span-2"></div>
        </div>
  
        <div class="row">
          <label for="clerk">Capturista</label>
          <input type="text" id="clerk" v-model="clerk" placeholder="Capturista" />
          <div class="cell span-2"></div>
        </div>
  
        <div class="row">
          <label for="client_type">Tipo de cliente</label>
          <select id="client_type" v-model="clientType" class="form-select">
            <option value="Asistencia">Asistencia</option>
            <option value="Aseguradora">Aseguradora</option>
            <option value="Cliente en general">Cliente en general</option>
          </select>
          <div class="cell span-2"></div>
        </div>
  
        <div class="row">
          <label class="checkbox-inline" for="pendingBilling">
            <input type="checkbox" id="pendingBilling" v-model="pendingBilling" />
            Pendiente por facturar
          </label>
          <div class="cell span-2"></div>
        </div>
  
        <div class="row">
          <label for="plate">Placa</label>
          <input type="text" id="plate" v-model="plate" placeholder="Placa" />
          <div class="cell span-2"></div>
        </div>
  
        <div class="row">
          <label for="engine">Serie</label>
          <input type="text" id="engine" v-model="engine" placeholder="Serie" />
          <div class="cell span-2"></div>
        </div>
  
        <div class="row actions">
          <div class="cell span-4">
            <button type="submit" class="btn-primary">Aplicar filtros</button>
          </div>
        </div>
      </form>
  
      <!-- Results -->
      <section class="results-card" id="results-section">
        <div class="results-head grid-head">
          <div></div>
          <h2>Resultados: {{ totalCount }}</h2>
          <div class="right">
            <button @click="cleanSelection" class="btn-clean">Limpiar selección</button>
            <button @click="selectAll" class="btn-clean">Seleccionar todo</button>
          </div>
        </div>
  
        <div class="table-scroll">
          <table class="table">
            <thead>
              <tr>
                <th>Seleccionar</th>
                <th>ID</th>
                <th>Fecha</th>
                <th>Cliente</th>
                <th>Expediente</th>
                <th>Tráfico</th>
                <th>Maniobras</th>
                <th>Kilometraje</th>
                <th>Subtotal</th>
                <th>Total</th>
                <th>Tipo</th>
                <th>Estatus</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(order, index) in queriedOrders" :key="index">
                <td>
                  <template v-if="order.status === 'Facturada'">
                    <span class="badge badge-warn invert">Facturada</span>
                  </template>
                  <template v-else>
                    <input type="checkbox" :value="order.note_ident" v-model="selectedNotes" />
                  </template>
                </td>
  
                <!-- ID badge -->
                <td @click="viewNoteDetails(order.type, order.note_ident)">
                  <span class="badge badge-id clickable">{{ order.note_number }}</span>
                </td>
  
                <!-- Fecha/Hora stacked -->
                <td><b>Fecha:</b>{{ order.request_time.substring(8, 10) }}/{{ order.request_time.substring(5, 7) }}/{{ order.request_time.substring(0, 4) }} <b>Hora: </b>{{ order.request_time.substring(11, 16) }}</td> <!-- Request time -->
  
                <!-- Cliente compact -->
                <td class="col-client" :title="order.client">
                  {{ shortClient(order.client) }}
                </td>
  
                <td class="col-file">{{ order.file_number }}</td>
                <td class="col-money">{{ order.cost_by_traffic }}</td>
                <td class="col-money">{{ order.maneuvers }}</td>
                <td class="col-money">{{ order.cost_by_km * order.total_kms }}</td>
                <td class="col-money">{{ order.subtotal }}</td>
                <td class="col-money">{{ order.total }}</td>
                <td class="col-type">{{ order.type }}</td>
  
                <td>
                  <span
                    v-if="order.status === 'Activo'"
                    class="badge badge-success">Activo</span>
                  <span
                    v-else-if="order.status === 'Asignada'"
                    class="badge badge-mint">Asignada</span>
                  <span
                    v-else-if="order.status === 'Cancelado'"
                    class="badge badge-danger">Cancelado</span>
                  <span
                    v-else-if="order.status === 'Programado'"
                    class="badge badge-purple">Pendiente</span>
                  <span
                    v-else-if="order.status === 'Completado'"
                    class="badge badge-blue">Completado</span>
                  <span
                    v-else-if="order.status === 'Facturada'"
                    class="badge badge-slate">Facturada</span>
                  <span v-else class="badge">{{ order.status }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
  
        <!-- Pagination -->
        <div class="pagination">
          <button @click="prevPage" :disabled="currentPage === 1" class="pg-btn" aria-label="Página anterior">
            <img src="@/assets/angulo-izquierdo.png" alt="Previous Page" />
          </button>
          <span
            v-for="pageNumber in TotalPages"
            :key="pageNumber"
            @click="goToPage(pageNumber)"
            :class="['pg-num', { active: pageNumber === currentPage }]"
          >
            {{ pageNumber }}
          </span>
          <button @click="nextPage" :disabled="currentPage >= TotalPages" class="pg-btn" aria-label="Página siguiente">
            <img src="@/assets/angulo-derecho.png" alt="Next Page" />
          </button>
        </div>
  
        <div class="actions-bottom">
          <button type="button" class="btn-primary" @click="handleSelectedNotes">Facturar</button>
        </div>
      </section>
  
      <!-- Popup (unchanged logic; slight style tidy kept) -->
      <div v-if="showPopup" class="popup-overlay" @click="closePopup">
        <div class="popup-content" @click.stop>
          <div class="popup-header">
            <div class="popup-header-left">
              <p><strong>Factura #</strong> {{ invoiceNumber[invoiceSeries] }} - {{ invoiceSeries }} (OT: VARIAS) &nbsp; <strong>Estatus:</strong> Pagada</p>
              <p><strong>Cliente #</strong> {{ clientInfo.client_ident }}</p>
            </div>
          </div>
  
          <div class="popup-body">
            <div class="popup-left-section">
              <p><strong>Nombre:</strong> {{ clientInfo.client_name }}</p>
              <p><strong>Dirección:</strong> Calle: {{ clientInfo.client_address.street }}</p>
              <p><strong>RFC:</strong> {{ clientInfo.client_rfc }} &nbsp; <strong>Tel:</strong> {{ clientInfo.phone }}</p>
              <p><strong>Ciudad:</strong> {{ clientInfo.client_address.city }}</p>
              <p><strong>CP:</strong> {{ clientInfo.client_address.codigoPostal }}</p>
  
              <div class="checkbox-group">
                <input type="checkbox" id="toggleFields1" v-model="invoiceBreakdown" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }">
                <label for="toggleFields1">Desglosar factura</label>
              </div>

              <div class="checkbox-group">
                <input type="checkbox" id="toggleFields1" v-model="invoiceMention">
                <label for="toggleFields1">Facturar con mención</label>
              </div>
  
              <div class="form-input-group">
                <p><strong>Serie: </strong></p>
                <select id="invoice_series" v-model="invoiceSeries"> <!--:disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"-->
                    <option value="NG">NG</option> <!--PASO DE CORRIENTE-->
                    <option value="NI">NI</option><!--GRUA-->
                    <option value="NR">NR</option><!--GRUA-->
                </select>
              </div>
              <button
                v-if="canGenerateInvoice"
                type="button"
                class="btn-primary"
                @click="generateInvoiceDocument"
                :disabled="saving_invoice"
                :class="{ 'saving-invoice': saving_invoice }"
              >
                {{ saving_invoice ? 'Generando...' : 'Generar factura' }}
              </button>
            </div>
  
            <div class="popup-right-section">
              <p class="horizontal-line"><strong>Fechas (CST)</strong></p>
              <p>Factura: {{ nowDateTime }}</p>
              <p class="horizontal-line"><strong>Costos</strong></p>
              <p>Descuento: 0.00</p>
              <p>Subtotal: {{ selectedNoteDetails.reduce((s, n) => Number(s) + (Number(n['subtotal'])||0), 0) }}</p>
              <p>IVA: {{ selectedNoteDetails.reduce((s, n) => Number(s) + (Number(n['iva'])||0), 0) }}</p>
              <p>IVA Retenido: {{ selectedNoteDetails.reduce((s, n) => Number(s) + (Number(n['subtotal']) * (applies_retention? 0.04 : 0)||0), 0) }}</p>
              <p class="horizontal-line"><strong>Total: {{
                selectedNoteDetails.reduce((s, n) => Number(s) + (Number(n['subtotal'])||0), 0) +
                selectedNoteDetails.reduce((s, n) => Number(s) + (Number(n['iva'])||0), 0) -
                selectedNoteDetails.reduce((s, n) => Number(s) + (Number(n['subtotal']) * (applies_retention? 0.04 : 0)||0), 0)
              }}</strong></p>
  
              <p><strong>Método de Pago: </strong>{{ this.client_payment_method }}</p>
              <p><strong>Tipo de Pago: </strong>{{ this.client_payment_type }}</p>
              <p><strong>Uso CFDI: </strong>{{ this.client_invoice_use }}</p>


              <div class="form-group-filters" v-if="invoiceMention">
                <label> UUID relacionado:</label>
                <input id="payment_method" type="text" v-model="this.related_cfdi" placeholder="Ingrese el UUID relacionado"/>
              </div>

              <div class="form-group-filters" v-if="invoiceMention">
                <label> Tipo de relación:</label>
                <input id="payment_method" type="text" v-model="this.relationship_type" placeholder="Ingrese el tipo de relación"/>
              </div>
  
              <!-- <p><strong>Tipo de Pago:</strong></p>
              <div class="form-group">
                <select id="payment-type" v-model="selectedNoteDetails[0].payment_type" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }">
                  <option value="99" v-if="selectedNoteDetails[0].payment_method === 'PPD'">POR DEFINIR</option>
                  <template v-else>
                    <option value="99">POR DEFINIR</option>
                    <option value="04">TARJETA DE CRÉDITO</option>
                    <option value="03">TRANSFERENCIA</option>
                    <option value="01">EFECTIVO</option>
                    <option value="28">TARJETA DE DÉBITO</option>
                    <option value="02">CHEQUE NOMINATIVO</option>
                  </template>
                </select>
              </div> -->
            </div>
          </div>
  
          <button class="popup-close-button" @click="closePopup">Close</button>
        </div>
      </div>
    </div>
  </template>

  <style>

:root{
    --brand:#FFC434; --brand-600:#e6b12e;
    --bg:#f7f7f8; --card:#fff; --border:#e8e8ea; --text:#1f2328; --muted:#70737a;
    --success:#22c55e; --danger:#e5484d; --mint:#86efac; --purple:#8A2BE2; --blue:#2563eb; --slate:#6E8bA3;
    --radius:8px; --shadow:0 1px 6px rgba(0,0,0,.06);
  }

</style>
  
  <style scoped>

   /* Make the table slightly denser and fix column widths */
.table {
  table-layout: fixed;          /* respect explicit widths */
  font-size: 11px;              /* down from 12px */
}
.table thead th { 
  font-size: 11.5px;
  padding: 5px 6px;             /* a touch tighter */
}
.table tbody td {
  padding: 4px 6px;             /* a touch tighter */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Narrow the wordiest columns */
.col-client      { max-width: 160px; width: 160px; }
.col-origin      { max-width: 180px; width: 180px; }
.col-destination { max-width: 180px; width: 180px; }

/* Slightly tighten other cells so everything fits */
.table td:nth-child(1)  { width: 84px;  }  /* ID (badge) */
.table td:nth-child(2)  { width: 170px; }  /* Fecha y hora */
.table td:nth-child(6)  { width: 92px;  }  /* Hora inicio */
.table td:nth-child(7)  { width: 110px; }  /* Hora contacto */
.table td:nth-child(8)  { width: 80px;  }  /* Unidad */
.table td:nth-child(9)  { width: 110px; }  /* Operador */
.table td:nth-child(10) { width: 110px; }  /* Expediente */
.table td:nth-child(11) { width: 120px; }  /* Capturista */
.table td:nth-child(12) { width: 90px;  }  /* Tipo */
.table td:nth-child(13) { width: 110px; }  /* Estatus */

/* On slightly smaller screens, compress client/address a bit more */
@media (max-width: 1360px) {
  .col-client      { max-width: 140px; width: 140px; }
  .col-origin,
  .col-destination { max-width: 160px; width: 160px; }
}

/* On tighter layouts, shave a bit of font size and padding */
@media (max-width: 1200px) {
  .table { font-size: 10.5px; }
  .table thead th { font-size: 11px; }
  .table tbody td { padding: 3px 5px; }
}
  /* Tokens */
  
  /* Layout/Top bar */
  .grouped-invoice-view{ background:var(--bg); min-height:100%; }
  .nav-bar-operations{ position:fixed; top:0; left:0; width:100%; height:56px; background:var(--brand); z-index:1000; box-shadow:var(--shadow); }
  .logo-button{ position:absolute; height:80%; top:50%; left:50%; transform:translate(-50%,-50%); cursor:pointer; margin:0; }
  .top-spacer{ height:56px; }
  
  /* Header */
  .panel-head{ margin:10px 10px 8px; display:flex; align-items:center; justify-content:space-between; }
  .panel-head h3{ margin:0; font-size:14px; color:var(--text); }
  .head-icon{ width:22px; height:22px; opacity:.9; }
  
  /* Filters */
  .filters-card{
    margin:0 10px 10px; background:var(--card); border:1px solid var(--border); border-radius:var(--radius);
    box-shadow:var(--shadow); padding:8px; display:grid; grid-template-columns:1fr; gap:6px; font-size:12px;
  }
  .filters-card .row{ display:grid; grid-template-columns:140px 320px 22px 320px; gap:4px; align-items:center; min-height:28px; }
  .filters-card .row.actions{ grid-template-columns:1fr; margin-top:2px; }
  .filters-card label{ color:var(--text); white-space:nowrap; }
  .filters-card .sep{ text-align:center; color:var(--muted); font-size:11px; }
  .filters-card input[type="text"], .filters-card input[type="date"], .filters-card select{
    height:26px; padding:0 8px; border:1px solid #d2d2d2; border-radius:6px; background:#fff; font-size:12px; outline:none;
  }
  .filters-card input:focus, .filters-card select:focus{ border-color:#bbb; box-shadow:0 0 0 2px rgba(255,196,52,.22); }
  .grayed-out{ background:#f2f2f2; color:#999; }
  .checkbox-inline{ display:flex; align-items:center; gap:8px; }
  
  /* Results */
  .results-card{ margin:0 10px 16px; background:var(--card); border:1px solid var(--border); border-radius:var(--radius); box-shadow:var(--shadow); overflow:hidden; }
  .results-head{ padding:8px 10px; border-bottom:1px solid var(--border); }
  .grid-head{ display:grid; grid-template-columns:1fr auto 1fr; align-items:center; }
  .grid-head h2{ margin:0; font-size:14px; text-align:center; }
  .grid-head .right{ text-align:right; }
  .btn-clean{ padding:6px 10px; border:1px solid var(--border); background:#fff; border-radius:8px; cursor:pointer; }
  
  /* Table */
  .table-scroll{ overflow-x:auto; }
  .table{ width:100%; border-collapse:collapse; table-layout:fixed; font-size:11px; line-height:1.15; }
  .table thead th{
    position:sticky; top:0; z-index:1; background:#f5f6f8; color:#475163; font-weight:600;
    border-bottom:1px solid var(--border); padding:6px 8px; white-space:nowrap;
  }
  .table tbody td{ padding:4px 6px; border-bottom:1px solid #f0f0f0; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
  .table tbody tr:nth-child(even) td{ background:#fcfcfd; }
  .table tbody tr:hover td{ background:#eef3ff; color:#0f172a; }
  
  /* Column widths to avoid horizontal scroll */
  .table td:nth-child(1){ width:96px; }   /* Seleccionar */
  .table td:nth-child(2){ width:96px; }   /* ID */
  .table td:nth-child(3){ width:120px; }  /* Fecha */
  .table td:nth-child(4){ width:220px; }  /* Cliente */
  .table td:nth-child(5){ width:110px; }  /* Expediente */
  .table td:nth-child(6){ width:110px; }  /* Tráfico */
  .table td:nth-child(7){ width:110px; }  /* Maniobras */
  .table td:nth-child(8){ width:120px; }  /* Kilometraje */
  .table td:nth-child(9){ width:120px; }  /* Subtotal */
  .table td:nth-child(10){ width:120px; } /* Total */
  .table td:nth-child(11){ width:90px; }  /* Tipo */
  .table td:nth-child(12){ width:110px; } /* Estatus */
  
  .col-client{ max-width:220px; }
  .col-money{ text-align:left; }
  .col-type{ text-transform:capitalize; }
  
  
  /* Badges */
  .badge{ display:inline-block; padding:2px 8px; border-radius:8px; font-size:11px; line-height:1.3; border:1px solid transparent; }
  .badge-id{ background:var(--brand); color:#000; font-weight:700; border-color:#f0c35a; }
  .badge-success{ background:var(--success); color:#fff; }
  .badge-mint{ background:var(--mint); color:#0a0a0a; }
  .badge-danger{ background:var(--danger); color:#fff; }
  .badge-purple{ background:var(--purple); color:#fff; }
  .badge-blue{ background:var(--blue); color:#fff; }
  .badge-slate{ background:var(--slate); color:#fff; }
  .badge-warn.invert{ background:orangered; color:#111; }
  .clickable{ cursor:pointer; }
  
  /* Pagination */
  .pagination{ display:flex; flex-wrap:wrap; justify-content:center; align-items:center; gap:6px; padding:10px; border-top:1px solid var(--border); }
  .pg-btn{ background:#fff; border:1px solid var(--border); border-radius:8px; padding:2px 6px; cursor:pointer; box-shadow:var(--shadow); }
  .pg-btn:disabled{ opacity:.5; cursor:not-allowed; }
  .pg-btn img{ width:18px; height:auto; display:block; }
  .pg-num{ min-width:28px; text-align:center; padding:4px 8px; border-radius:8px; border:1px solid var(--border); background:#fff; cursor:pointer; user-select:none; }
  .pg-num.active{ background:var(--brand); border-color:#e0b12b; }
  
  /* Bottom actions */
  .actions-bottom{ display:flex; justify-content:center; padding:10px; }
  
  /* Buttons */
  .btn-primary{ padding:6px 12px; font-size:12px; border-radius:8px; background:var(--brand); border:none; cursor:pointer; box-shadow:var(--shadow); }
  .btn-primary:hover{ background:var(--brand-600); }
  .saving-invoice {
    opacity: 0.5; /* You can adjust the opacity to your preference */
    cursor: not-allowed;
    position: relative; /* Ensure button's position is relative */
}
.saving-invoice::after {
    content: "Espere a que se guarde la factura"; /* Text to show on mouse hover */
    position: absolute;
    top: -50%; /* Center the text vertically */
    left: 50%; /* Center the text horizontally */
    transform: translate(-50%, -50%); /* Center the text both vertically and horizontally */
    background-color: rgba(0, 0, 0, 0.8);
    color: #fff;
    padding: 10px;
    border-radius: 5px;
    white-space: nowrap;
    z-index: 999;
    opacity: 0; /* Initially hide the text */
    transition: opacity 0.3s ease;
}
.saving-invoice:hover::after {
    opacity: 1; /* Show the text on hover */
}
  /* Popup (kept your palette) */
  .popup-overlay{ position:fixed; inset:0; background:rgba(0,0,0,.5); display:flex; justify-content:center; align-items:center; z-index:2000; }
  .popup-content{ background:#fff; padding:20px; border-radius:10px; width:min(800px, 92vw); box-shadow:0 0 15px rgba(0,0,0,.3); color:#000; }
  .popup-header{ display:flex; justify-content:space-between; border-bottom:1px solid #000; padding-bottom:10px; margin-bottom:10px; }
  .popup-body{ display:flex; justify-content:space-between; align-items:flex-start; gap:16px; }
  .popup-left-section, .popup-right-section{ width:48%; }
  .popup-right-section{ border-left:1px solid #000; padding-left:15px; }
  .popup-close-button{ background-color:var(--brand); border:none; padding:10px 20px; cursor:pointer; margin-top:15px; color:#000; font-weight:bold; float:right; border-radius:8px; }
  .horizontal-line{ border-bottom:1px solid #000; padding-bottom:5px; }
  
  /* Responsive compression */
  @media (max-width:1200px){
    .filters-card .row{ grid-template-columns:120px minmax(180px,1fr) 18px minmax(180px,1fr); }
    .table{ font-size:10.5px; }
    .col-client{ max-width:200px; }
  }
  @media (max-width:900px){
    .filters-card .row{ grid-template-columns:120px 1fr; }
    .filters-card .sep, .filters-card .row>.cell{ display:none; }
  }

  .row-rel { position: relative; }
  .suggestions {
    position: absolute;
    top: calc(26px + 4px);
    left: 140px;
    width: 320px;
    max-height: 220px;
    overflow-y: auto;
    background: #fff;
    border: 1px solid var(--border);
    border-radius: 8px;
    box-shadow: var(--shadow-2);
    list-style: none; margin: 0; padding: 4px 0; z-index: 10;
  }
  .suggestions li {
    padding: 6px 10px;
    font-size: 12px;
    cursor: pointer;
  }
  .suggestions li:hover { background: #f2f6ff; }
  </style>
  

  <script>

  import axios from 'axios';
  import Swal from 'sweetalert2'
  import Fuse from 'fuse.js';
  
  export default {
  
      name: "OrdersTableView",
      
      data() {
          return {
              permissions: [],
              saving_invoice: false,
              noteIdent: '',
              noteIdentEnd: '',
              startDate: '',
              endDate: '',
              clientName: '',
              clientIdent: '',
              origin: '',
              destination: '',
              unit: '',
              operator: '',
              file: '',
              clerk: '',
              plate: '',
              clientType: '',
              engine: '',
              queriedOrders: [],
              selectedNotes: [],
              currentPage: 1,
              pageSize:20,
              nOrders: 1,
              StatusCounts: {
                  Activo: 1, // Example hardcoded value
                  Cancelado: 1, // Example hardcoded value
                  Programado: 1, // Example hardcoded value
                  Completado: 1, // Example hardcoded value
                  Asignada: 1,
                  Facturada: 1
              },
              isActive: '',
              isAssigned: '',
              isCanceled: '',
              isCompleted: '',
              isProgrammed: '',
              pendingBilling: true,
              selectedNoteDetails: [],
              showPopup: false,
              clientInfo: {},
              nowDateTime: this.getCurrentDateTime(),
              invoiceBreakdown: false,
              invoiceMention: false,
              prefered_product_key_traffic: '78101803',
              prefered_measurement_unit_traffic: 'E48',
              prefered_product_key_pension_days: '78181702',
              prefered_measurement_unit_pension_days: 'E48',
              prefered_product_key_cost_km: '78121603',
              prefered_measurement_unit_cost_km: 'E48',
              prefered_product_key_maneuvers: '81141601',
              prefered_measurement_unit_maneuvers: 'E48',
              prefered_product_key_service_hours: '78101803',
              prefered_measurement_unit_service_hours: 'E48',
              // invoiceBreakdown: false,
              invoiceBreakdownEdit: false,
              applies_retention: false,
              totalCount: 0,
              invoiceNumber: 0,
              invoiceSeries: 'NG',
              billingPending: false,
              relationship_type: '',
              related_cfdi: '',
              client_payment_method:'',
              client_payment_type:'',
              client_invoice_use:'',
              // client suggestions
        clients: [],
        filteredClients: [],
        fuse: null,
        highlightedIndex: -1
          };
      },
  
      computed: {
          canAccessGroupedBilling() {
              return this.hasAnyPerm(['accounting.view_grouped_billing'])
          },
          canCreateInvoice() {
              return this.hasAnyPerm(['accounting.create_invoice'])
          },
          canUpdateInvoice() {
              return this.hasAnyPerm(['accounting.update_invoice'])
          },
          canManageTransactions() {
              return this.hasAnyPerm(['accounting.manage_invoice_transactions'])
          },
          canGenerateDocuments() {
              return this.hasAnyPerm(['accounting.generate_invoice_documents'])
          },
          canGenerateInvoice() {
              return this.canCreateInvoice && this.canUpdateInvoice && this.canManageTransactions && this.canGenerateDocuments
          },
          effectiveEndDate() {
              return this.endDate || this.startDate; // Use startDate if endDate is empty
          },
          PaginatedOrders() {
              //**Contains page of orders with status NE to "Programado" */
              return this.queriedOrders
          },
  
          TotalPages() {
              // console.log("kiba", this.StatusCounts)
              // console.log("pendeja", this.StatusCounts.Programado)
              // console.log("AAaAA0", this.StatusCounts.Completado)
              // console.log("puta", (this.StatusCounts.Programado + this.StatusCounts.Completado))
              // console.log("chosto", Math.ceil((this.StatusCounts.Activo + this.StatusCounts.Asignada + this.StatusCounts.Programado + this.StatusCounts.Completado + this.StatusCounts.Asignada) / this.pageSize)) 
              return Math.ceil((this.StatusCounts.Activo + this.StatusCounts.Asignada + this.StatusCounts.Programado + this.StatusCounts.Completado + this.StatusCounts.Facturada) / this.pageSize);
              // return Math.ceil(this.assistance_n_inProcessOrders / this.assistancePageSize);
          },  
      },
  
      methods: {
          loadPermissions() {
              try {
                  this.permissions = JSON.parse(localStorage.getItem('userPermissions')) || []
              } catch (error) {
                  this.permissions = []
              }
          },
          hasPerm(perm) {
              if (!perm) return false
              if (this.permissions.includes(perm)) return true
              return this.permissions.includes(`access_control.${perm}`)
          },
          hasAnyPerm(perms) {
              if (!Array.isArray(perms) || perms.length === 0) return false
              return perms.some((perm) => this.hasPerm(perm))
          },

        cleanSelection() {
          this.selectedNotes = [];
          this.selectedNoteDetails = [];
        },
        async selectAll() {
          const apiDirectory = process.env.API_DIRECTORY;
          const payload = {
            note_ident: this.noteIdent,
            note_ident_end: this.noteIdentEnd,
            start_date: this.formatToDatetime(this.startDate, '00:00'),
            end_date: this.formatToDatetime(this.effectiveEndDate, '23:59'),
            client_name: this.clientName || "",
            origin: this.origin,
            destination: this.destination,
            unit: this.unit,
            operator: this.operator,
            file: this.file,
            clerk: this.clerk,
            plate: this.plate,
            client_type: this.clientType,
            engine: this.engine,
            is_active: this.isActive,
            is_completed: this.isCompleted,
            is_assigned: this.isAssigned,
            is_canceled: this.isCanceled,
            is_programmed: this.isProgrammed,
            note_type: this.noteType,
            pending_billing: this.pendingBilling,
            client_ident: this.clientName === "" ? "" : this.clientIdent,
          };

          try {
            // 🔹 Step 1: Check total count using the statistics endpoint
            const statsResponse = await axios.post(
              `${apiDirectory}/get-global-filtered-statistics`,
              payload
            );

            let totalCount = 0;
            statsResponse.data.forEach(item => {
              totalCount += item.count;
            });

            // 🔹 Step 2: Abort if there are too many notes
            if (totalCount > 200) {
              Swal.fire({
              icon: 'warning',
              title: '¡Ups!',
              text: `Hay demasiadas notas para seleccionar (${totalCount}). Por favor, ajusta tus filtros.`,
            });
              return;
            }
            // 🔹 Step 3: Fetch all pages normally
            let currentPage = 1;
            let allOrders = [];
            let totalPages = 1;

            do {
              const response = await axios.post(
                `${apiDirectory}/get-global-filtered-orders?page=${currentPage}&page_size=${this.pageSize}`,
                payload
              );
              const data = response.data;
              allOrders = allOrders.concat(data.results);

              if (data.count) {
                totalPages = Math.ceil(data.count / this.pageSize);
              } else if (!data.next) {
                totalPages = currentPage;
              }

              currentPage++;
            } while (currentPage <= totalPages);

            // 🔹 Step 4: Select all non-Facturada notes
            this.selectedNotes = allOrders
              .filter(order => order.status !== 'Facturada')
              .map(order => order.note_ident);

           Swal.fire({
            icon: 'success',
            title: '¡Listo!',
            text: `Se seleccionaron ${totalCount} notas de todas las páginas.`,
          });
          } catch (error) {
            const errorMessage = error.response ? error.response.data.error : error.message;
            Swal.fire({
              icon: 'error',
              title: 'Error Selecting All',
              text: errorMessage,
            });
          }
        },

        async fetchClients() {
        try {
          const apiDirectory = process.env.API_DIRECTORY;
          const response = await axios.get(`${apiDirectory}/get-privileged-clients`);
          this.clients = response.data;
          this.initializeFuse();
        } catch (error) {
          console.error('Error fetching clients:', error);
        }
      },
      initializeFuse() {
        const options = {
          keys: ['client_name'],
          threshold: 0.3,
          ignoreLocation: true,
          includeScore: false,
        };
        this.fuse = new Fuse(this.clients, options);
      },
      filterSuggestions() {
        const searchTerm = (this.clientName || '').toLowerCase().trim();
        if (!searchTerm) { this.filteredClients = []; this.highlightedIndex = -1; return; }
        this.filteredClients = this.clients.filter(c =>
          (c.client_name || '').toLowerCase().includes(searchTerm) ||
          (c.client_ident || '').toLowerCase().includes(searchTerm)
        );
        this.highlightedIndex = -1;
      },
      selectClient(client) {
        this.clientName = client.client_name;
        this.clientIdent = client.client_ident;
        this.filteredClients = [];
      },

        // UI helpers
    shortClient(name) {
      const s = String(name || '');
      return s.length > 24 ? s.slice(0, 23) + '…' : s;
    },
          getCurrentDateTime() {
              const now = new Date();
              return now.toLocaleString("en-US", { timeZone: "CST" }); // Adjust format and locale as needed
              },
  
          backMainPanel() {
              window.location.href = '/main-panel';
          },
  
          viewNoteDetails(notetype, noteID) {
              // Calls EditNote component for aux or assistance notes
              Swal.fire({
                  title: '¿Estás seguro?',
                  text: `¿Quieres ver los detalles de la nota ${noteID}?`,
                  icon: 'question',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  confirmButtonText: 'Sí, ver detalles',
                  cancelButtonText: 'No, cancelar'
              }).then((result) => {
                  if (result.isConfirmed) {
                      this.$router.push({ name: 'EditNote', params: { notetype, noteID } });
                  }
              });
          },
          // handleBillingPending() {
              // console.log(this.billingPending);
              // if (this.billingPending) {
              // this.noteIdent = "";
              // this.noteIdentEnd = "";
              // this.startDate = "";
              // this.effectiveEndDate = "";
              // this.clientName = "";
              // this.origin = "";
              // this.destination = "";
              // this.unit = "";
              // this.operator = "";
              // this.file = "";
              // this.clerk = "";
              // this.plate = "";
              // this.engine = "";
              // this.isActive = "";
              // this.isCompleted = true;
              // this.isAssigned = "";
              // this.isCanceled = "";
              // this.isProgrammed = "";
              // this.noteType = "";
              // }
          // },
          formatToDatetime(date, time) {
              if (!date) {
                  return '';
              }
              return `${date}T${time}`
          },
          goToPage(pageNumber) {
              this.currentPage = pageNumber;
              const page = this.currentPage
              this.queryOrders(page);
          },
  
          nextPage() {
              if (this.currentPage < this.TotalPages) this.currentPage++;
              const page = this.currentPage
              this.queryOrders(page);
          },
  
          prevPage() {
              if (this.currentPage > 1) this.currentPage--;
              const page = this.currentPage
              this.queryOrders(page);
          },
  
          async handleSelectedNotes() {
              // console.log(this.selectedNotes); // Array of selected note IDs
              if (!this.selectedNotes || this.selectedNotes.length <= 1) {
                  Swal.fire({
                  icon: 'warning',
                  title: 'Selección insuficiente',
                  text: 'Debe seleccionar al menos dos notas para facturar.',
                  confirmButtonText: 'Entendido'
                  });
                  return;
              }
              const apiDirectory = process.env.API_DIRECTORY;
              const response = await axios.post(`${apiDirectory}/calculate-invoice-number`);
  
          // Store the invoice number in your component state
              this.invoiceNumber = response.data[this.invoiceSeries] ?? 1;
              // console.log(this.invoiceNumber);    
              for (const noteID of this.selectedNotes) {
              try {
                  let response;
                  if (noteID.includes("MTC")) {
                      response = await axios.get(`${apiDirectory}/notes/${noteID}/`);
                  } else {
              response = await axios.get(`${apiDirectory}/notes/${noteID}/`);
              }
  
              // Add the fetched note details to the list
              this.selectedNoteDetails.push({
                  ...response.data,
              });
  
              // console.log(this.selectedNoteDetails);
              response = await axios.get(`${apiDirectory}/clients/` + this.selectedNoteDetails[0]['client'] + '/');
              this.clientInfo = response.data;
              if (this.clientInfo.prefered_product_key_traffic) {
                      this.prefered_product_key_traffic = this.clientInfo.prefered_product_key_traffic;
              }
              if (this.clientInfo.prefered_measurement_unit_traffic) {
                  this.prefered_measurement_unit_traffic = this.clientInfo.prefered_measurement_unit_traffic;
              }
              this.prefered_legend_traffic = this.clientInfo.prefered_legend_traffic || '';
              this.prefered_legend_maneuvers = this.clientInfo.prefered_legend_maneuvers || '';
              this.prefered_legend_cost_km = this.clientInfo.prefered_legend_cost_km || '';
              this.prefered_legend_pension_days = this.clientInfo.prefered_legend_pension_days || '';
              this.prefered_legend_service_hours = this.clientInfo.prefered_legend_service_hours || '';
              if (this.clientInfo.prefered_product_key_cost_km) {
                  this.prefered_product_key_cost_km = this.clientInfo.prefered_product_key_cost_km;
              }
              if (this.clientInfo.prefered_measurement_unit_cost_km) {
                  this.prefered_measurement_unit_cost_km = this.clientInfo.prefered_measurement_unit_cost_km;
              }
              if (this.clientInfo.prefered_product_key_maneuvers) {
                  this.prefered_product_key_maneuvers = this.clientInfo.prefered_product_key_maneuvers;
              }
              if (this.clientInfo.prefered_measurement_unit_maneuvers) {
                  this.prefered_measurement_unit_maneuvers = this.clientInfo.prefered_measurement_unit_maneuvers;
              }
              if (this.clientInfo.prefered_product_key_service_hours) {
                  this.prefered_product_key_service_hours = this.clientInfo.prefered_product_key_service_hours;
              }
              if (this.clientInfo.prefered_measurement_unit_service_hours) {
                  this.prefered_measurement_unit_service_hours = this.clientInfo.prefered_measurement_unit_service_hours;
              }
              if (this.clientInfo.applies_retention) {
                  this.applies_retention = this.clientInfo.applies_retention;
              }
              if (this.clientInfo.client_payment_method) {
                  this.client_payment_method = this.clientInfo.client_payment_method;
              }
              if (this.clientInfo.client_payment_type) {
                  this.client_payment_type = this.clientInfo.client_payment_type;
              }
              if (this.clientInfo.client_invoice_use) {
                  this.client_invoice_use = this.clientInfo.client_invoice_use;
              }
              // console.log(this.clientInfo);
  
  
          } catch (error) {
          console.error(`Failed to fetch details for note ${noteID}:`, error);
          }
          }
              console.log(this.selectedNoteDetails); // Array of selected note IDs
              this.showPopup = true;
  
               // Run saveBilling after fetching notes
              // await this.generateInvoiceDocument();
  
          },
  
          async fetchStatistics(){
              if (!this.canAccessGroupedBilling) {
                  return
              }
              const payload = {
                  note_ident: this.noteIdent,
                  note_ident_end: this.noteIdentEnd,
                  start_date: this.formatToDatetime(this.startDate, '00:00'),
                  end_date: this.formatToDatetime(this.effectiveEndDate, '23:59'),
                  client_name: this.clientName || "",
                  origin: this.origin,
                  destination: this.destination,
                  unit: this.unit,
                  operator: this.operator,
                  file: this.file,
                  clerk: this.clerk,
                  plate: this.plate,
                  client_type: this.clientType,
                  engine: this.engine,
                  is_active: this.isActive,
                  is_completed: this.isCompleted,
                  is_assigned: this.isAssigned,
                  is_canceled: this.isCanceled,
                  is_programmed: this.isProgrammed,
                  note_type: this.noteType,
                  pending_billing: this.pendingBilling,
                  client_ident: this.clientName === "" ? "" : this.clientIdent,
              };
              let response 
              const apiDirectory = process.env.API_DIRECTORY;
              // Request schedules status as or condition (Check view for details)
              try{
              response = await axios.post(`${apiDirectory}/get-global-filtered-statistics`, payload);
                  const statusDict = {
                      1: "Activo",
                      2: "Cancelado",
                      3: "Programado",
                      4: "Completado",
                      5: "Asignada",
                      6: "Facturada"
                  };
                  // Initialization to avoid undefined on bar
                  let statusCounts = {
                      "Activo":0,
                      "Cancelado":0,
                      "Programado":0,
                      "Completado":0,
                      "Asignada":0,
                      "Facturada":0
                  };
                  this.totalCount = 0;
                  // Assign based on response 
                  // console.log(response.data);
                  const responseData = response.data;
                  // console.log(responseData);
                  responseData.forEach(item => {
                      const status = statusDict[item.status]; // Get the name from the statusDict
                      const count = item.count;
                      statusCounts[status] = count;
                      this.totalCount += count;
                  });
                  // Returned from statistics endpoint 
                  this.StatusCounts = statusCounts;
              }
              catch(error){
                  console.error("There was an error fetching the statistics",error)
              }
          },
  
          closePopup() {
      this.showPopup = false;
      this.invoiceMention = false;
      this.selectedNoteDetails = [];
    },
  
          async queryOrders(){
              if (!this.canAccessGroupedBilling) {
                  Swal.fire('Sin acceso', 'No tienes permisos para facturación agrupada.', 'warning')
                  return
              }
              this.fetchStatistics()
              const payload = {
                  note_ident: this.noteIdent,
                  note_ident_end: this.noteIdentEnd, 
                  start_date: this.formatToDatetime(this.startDate, '00:00'),
                  end_date: this.formatToDatetime(this.effectiveEndDate, '23:59'),
                  client_name: this.clientName || "",
                  origin: this.origin,
                  destination: this.destination,
                  unit: this.unit,
                  operator: this.operator,
                  file: this.file,
                  clerk: this.clerk,
                  plate: this.plate,
                  client_type: this.clientType,
                  engine: this.engine,
                  is_active: this.isActive,
                  is_completed: this.isCompleted,
                  is_assigned: this.isAssigned,
                  is_canceled: this.isCanceled,
                  is_programmed: this.isProgrammed,
                  note_type: this.noteType,
                  pending_billing: this.pendingBilling,
                  client_ident: this.clientName === "" ? "" : this.clientIdent,
              };
  
              try {
                  const apiDirectory = process.env.API_DIRECTORY;
                  // Set responseType to 'blob' to handle file download
                  const response = await axios.post(`${apiDirectory}/get-global-filtered-orders?page=${this.currentPage}&page_size=${this.pageSize}`, payload, {
                  });
                  
                  const responseData = response
  
                  responseData.data.results.forEach(order => {
                      if (!('contact_time' in order) || order.contact_time === null) {
                          order.contact_time = '';
                      }
                      if (!('start_time' in order) || order.start_time === null) {
                          order.start_time = '';
                      }
                      if (!('unit_id' in order) || order.unit_id === null) {
                          order.unit_id = 'N/A';
                      }
                      if (!('operator_first_name' in order) || order.operator_first_name === null) {
                          order.operator_first_name = 'N/A';
                      }
                      if (!('operator_employee_ident' in order) || order.operator_employee_ident === null) {
                          order.operator_employee_ident = 'N/A';
                      }
                  });
                  this.queriedOrders = responseData.data.results
              } catch (error) {
                  const errorMessage = error.response ? error.response.data.error : error.message;
                  Swal.fire({
                      icon: 'error',
                      title: 'Error Generando Reporte',
                      text: errorMessage,
                  });
              }
          },
          async fetchNoteDetails(noteID) {
        console.log(noteID,'this is the note id i got and will determine the endpoint i call')
        // Determine which endpoint to call based on the route params
        if (noteID.includes("MTC")){
          try {
          const apiDirectory = process.env.API_DIRECTORY;
          const response = await axios.get(`${apiDirectory}/forklift-notes/` + noteID + "/");
          this.noteDetails = response.data;
          this.noteType = 3; // Assuming the response includes a type field
        } catch (error) {
          console.error("Failed to fetch note details:", error);
        }
        }
        else if (noteID.includes("IND")){
          try {
          const apiDirectory = process.env.API_DIRECTORY;
          const response = await axios.get(`${apiDirectory}/industrial-notes/` + noteID + "/");
          this.noteDetails = response.data;
          this.noteType = 5;
        } catch (error) {
          console.error("Failed to fetch note details:", error);
        }
        }
        else{
        try {
          const apiDirectory = process.env.API_DIRECTORY;
          const response = await axios.get(`${apiDirectory}/notes/` + noteID + "/");
          this.noteDetails = response.data;
          this.noteType = response.data.type; // Assuming the response includes a type field
        } catch (error) {
          console.error("Failed to fetch note details:", error);
          // Handle error (e.g., show user feedback)
        }
      }
      },
      async saveBilling() {
  // ---------- helpers ----------
  const toCents   = (n) => Math.round(Number(n) * 100);
  const fromCents = (c) => c / 100;
  const moneyStr  = (cents) => fromCents(cents).toFixed(2);

  // Largest-remainder allocator: distributes totalCents across weights exactly.
  function allocateByWeights(weights, totalCents) {
    const sumW = weights.reduce((a, b) => a + b, 0);
    if (sumW === 0) return weights.map(() => 0);

    const exacts = weights.map(w => (w * totalCents) / sumW);
    const floors = exacts.map(x => Math.floor(x));
    let allocated = floors.reduce((a, b) => a + b, 0);
    let remaining = totalCents - allocated;

    const idxByRemainder = exacts
      .map((x, i) => ({ i, rem: x - Math.floor(x) }))
      .sort((a, b) => b.rem - a.rem)
      .map(o => o.i);

    for (let k = 0; k < remaining; k++) floors[idxByRemainder[k]] += 1;
    return floors;
  }

  try {
    const apiDirectory = process.env.API_DIRECTORY;
    const firstNote = this.selectedNoteDetails[0];
    const client = await axios.get(`${apiDirectory}/client/` + firstNote['client'] + "/");

    const orderNumbers = this.selectedNoteDetails.map(n => n.note_number).join(', ');
    const appliesRetention = !!this.clientInfo?.applies_retention;
    const retentionPerc = appliesRetention ? 0.04 : 0.00;

    // ---------- HEADER amounts in integer cents (exact) ----------
    // Build per-note subtotals in cents
    const itemSubtotalCents = this.selectedNoteDetails.map(n => toCents(n.subtotal || 0));  
    const grandSubtotalCents = itemSubtotalCents.reduce((a, b) => a + b, 0);

    const headerIvaCents       = Math.round(grandSubtotalCents * 0.16);           // 16% of subtotal
    const headerRetentionCents = Math.round(grandSubtotalCents * retentionPerc);  // 4% or 0%
    const headerTotalCents     = grandSubtotalCents + headerIvaCents - headerRetentionCents;

    // ---------- conceptos (header lines) ----------
    let conceptos;

    if (this.invoiceBreakdown === false) {
      // Single concepto equals the whole invoice; taxes must match header exactly
      conceptos = {
        1: {
          clave_prod_serv: this.prefered_product_key_traffic,
          cantidad: '1',
          clave_unidad: this.prefered_measurement_unit_traffic,
          descripcion: (this.prefered_legend_traffic || 'SERVICIO') + ' DE LAS ORDENES ' + orderNumbers,
          valor_unitario: moneyStr(grandSubtotalCents),   // base subtotal
          objeto_imp: '02',
          no_identificacion: '8635',
          impuestos: {
            traslados: {
              impuesto: '002',
              tipo_factor: 'Tasa',
              tasa_o_cuota: '0.16',
              importe: moneyStr(headerIvaCents),
            },
            retenciones: {
              impuesto: '002',
              tipo_factor: 'Tasa',
              tasa_o_cuota: retentionPerc.toString(),
              importe: moneyStr(headerRetentionCents),
            }
          },
        }
      };
    } else {
      // Breakdown by category — we allocate header IVA/Retention proportionally to each category subtotal
      const grandTrafficCents     = this.selectedNoteDetails.reduce((s, n) => s + toCents(n.cost_by_traffic || 0), 0);
      const grandHighwayTollCents = this.selectedNoteDetails.reduce((s, n) => s + toCents(n.highway_tolls || 0), 0);
      const grandManeuversCents   = this.selectedNoteDetails.reduce((s, n) => s + toCents(n.maneuvers || 0), 0);
      const grandKmsCents         = this.selectedNoteDetails.reduce((s, n) => s + toCents((Number(n.cost_by_km) || 0) * (Number(n.total_kms) || 0)), 0);
      const grandImpoundLotCents  = this.selectedNoteDetails.reduce((s, n) => s + toCents(n.lot_total_cost || 0), 0);
      const grandPermissionsCents = this.selectedNoteDetails.reduce((s, n) => s + toCents(n.cost_by_permissions || 0), 0);
      const grandHrCents          = this.selectedNoteDetails.reduce((s, n) => s + toCents((Number(n.cost_by_hr) || 0) * (Number(n.total_hours) || 0)), 0);

      const catSubtotals = [
        grandTrafficCents,
        grandManeuversCents,
        grandHighwayTollCents,
        grandKmsCents,
        grandImpoundLotCents,
        grandPermissionsCents,
        grandHrCents
      ];

      const ivaPerCat       = allocateByWeights(catSubtotals, headerIvaCents);
      const retPerCat       = allocateByWeights(catSubtotals, headerRetentionCents);

      conceptos = {
        1: { // TRÁFICO
          clave_prod_serv: this.prefered_product_key_traffic,
          cantidad: '1',
          clave_unidad: this.prefered_measurement_unit_traffic,
          descripcion: (this.prefered_legend_traffic || 'TRAFICO') + ' DE LAS ORDENES ' + orderNumbers,
          valor_unitario: moneyStr(grandTrafficCents),
          objeto_imp: '02',
          no_identificacion: '8635',
          impuestos: {
            traslados:   { impuesto: '002', tipo_factor: 'Tasa', tasa_o_cuota: '0.16', importe: moneyStr(ivaPerCat[0]) },
            retenciones: { impuesto: '002', tipo_factor: 'Tasa', tasa_o_cuota: retentionPerc.toString(), importe: moneyStr(retPerCat[0]) }
          }
        },
        2: { // MANIOBRAS
          clave_prod_serv: this.prefered_product_key_maneuvers,
          cantidad: '1',
          clave_unidad: this.prefered_measurement_unit_maneuvers,
          descripcion: (this.prefered_legend_maneuvers || 'MANIOBRAS') + ' DE LAS ORDENES ' + orderNumbers,
          valor_unitario: moneyStr(grandManeuversCents),
          objeto_imp: '02',
          no_identificacion: '8635',
          impuestos: {
            traslados:   { impuesto: '002', tipo_factor: 'Tasa', tasa_o_cuota: '0.16', importe: moneyStr(ivaPerCat[1]) },
            retenciones: { impuesto: '002', tipo_factor: 'Tasa', tasa_o_cuota: retentionPerc.toString(), importe: moneyStr(retPerCat[1]) }
          }
        },
        3: { // CASETAS
          clave_prod_serv: this.prefered_measurement_unit_traffic,
          cantidad: '1',
          clave_unidad: this.prefered_measurement_unit_traffic,
          descripcion: 'CASETAS DE LAS ORDENES ' + orderNumbers,
          valor_unitario: moneyStr(grandHighwayTollCents),
          objeto_imp: '02',
          no_identificacion: '8635',
          impuestos: {
            traslados:   { impuesto: '002', tipo_factor: 'Tasa', tasa_o_cuota: '0.16', importe: moneyStr(ivaPerCat[2]) },
            retenciones: { impuesto: '002', tipo_factor: 'Tasa', tasa_o_cuota: retentionPerc.toString(), importe: moneyStr(retPerCat[2]) }
          }
        },
        4: { // KILOMETRAJE
          clave_prod_serv: this.prefered_product_key_cost_km,
          cantidad: '1',
          clave_unidad: this.prefered_measurement_unit_cost_km,
          descripcion: (this.prefered_legend_cost_km || 'KILOMETRAJE') + ' DE LAS ORDENES ' + orderNumbers,
          valor_unitario: moneyStr(grandKmsCents),
          objeto_imp: '02',
          no_identificacion: '8635',
          impuestos: {
            traslados:   { impuesto: '002', tipo_factor: 'Tasa', tasa_o_cuota: '0.16', importe: moneyStr(ivaPerCat[3]) },
            retenciones: { impuesto: '002', tipo_factor: 'Tasa', tasa_o_cuota: retentionPerc.toString(), importe: moneyStr(retPerCat[3]) }
          }
        },
        5: { // PENSIÓN
          clave_prod_serv: this.prefered_product_key_pension_days,
          cantidad: '1',
          clave_unidad: this.prefered_measurement_unit_pension_days,
          descripcion: (this.prefered_legend_pension_days || 'PENSION') + ' DE LAS ORDENES ' + orderNumbers,
          valor_unitario: moneyStr(grandImpoundLotCents),
          objeto_imp: '02',
          no_identificacion: '8635',
          impuestos: {
            traslados:   { impuesto: '002', tipo_factor: 'Tasa', tasa_o_cuota: '0.16', importe: moneyStr(ivaPerCat[4]) },
            retenciones: { impuesto: '002', tipo_factor: 'Tasa', tasa_o_cuota: retentionPerc.toString(), importe: moneyStr(retPerCat[4]) }
          }
        },
        6: { // PERMISOS
          clave_prod_serv: this.prefered_product_key_traffic,
          cantidad: '1',
          clave_unidad: this.prefered_measurement_unit_traffic,
          descripcion: 'COSTO POR PERMISOS DE LAS ORDENES ' + orderNumbers,
          valor_unitario: moneyStr(grandPermissionsCents),
          objeto_imp: '02',
          no_identificacion: '8635',
          impuestos: {
            traslados:   { impuesto: '002', tipo_factor: 'Tasa', tasa_o_cuota: '0.16', importe: moneyStr(ivaPerCat[5]) },
            retenciones: { impuesto: '002', tipo_factor: 'Tasa', tasa_o_cuota: retentionPerc.toString(), importe: moneyStr(retPerCat[5]) }
          }
        },
        7: { // HORAS
          clave_prod_serv: this.prefered_product_key_service_hours,
          cantidad: '1',
          clave_unidad: this.prefered_measurement_unit_service_hours,
          descripcion: (this.prefered_legend_service_hours || 'COSTOS POR HORAS') + ' DE LAS ORDENES ' + orderNumbers,
          valor_unitario: moneyStr(grandHrCents),
          objeto_imp: '02',
          no_identificacion: '8635',
          impuestos: {
            traslados:   { impuesto: '002', tipo_factor: 'Tasa', tasa_o_cuota: '0.16', importe: moneyStr(ivaPerCat[6]) },
            retenciones: { impuesto: '002', tipo_factor: 'Tasa', tasa_o_cuota: retentionPerc.toString(), importe: moneyStr(retPerCat[6]) }
          }
        },
      };
    }

    // ---------- Build billingInfo with header-consistent conceptos ----------
    this.billingInfo = {
      cartaporte: 0,
      receptor: {
        rfc: client.data['client_rfc'],
        nombre: client.data['client_name'],
        uso_cfdi: this.client_invoice_use,
        domicilio_fiscal_receptor: client.data['client_address']['codigoPostal'],
        regimen_fiscal_receptor: client.data['tax_regime']
      },
      metodo_pago: this.client_payment_method,
      forma_pago: this.client_payment_type,
      serie: this.invoiceSeries,
      folio: String(this.invoiceNumber),
      conceptos,
      tipo_relacion: String(this.relationship_type),
      uuid_relacionado: this.related_cfdi,
    };

    // ---------- Stamp, create invoice, transactions, balance ----------
    return this.invoiceStamping(this.billingInfo)
      .then(async (stampedInvoice) => {
        try {
          const type = firstNote.internal_payment_type === '4' ? 'Credito' : 'Contado';
          const headerTotalStr = moneyStr(headerTotalCents);

          const invoiceResponse = await axios.post(`${apiDirectory}/create-invoice/`, {
            invoice_ident: this.invoiceNumber + '-' + this.invoiceSeries,
            invoice_series: this.invoiceSeries,
            invoice_number: Number(this.invoiceNumber),
            date_issued: new Date().toISOString(),
            xml: stampedInvoice,
            invoice_type: type,
            amount: headerTotalStr,
            balance: 0,
            note_ids: this.selectedNoteDetails.map(detail => detail.id),
          });

          this.invoice_id = invoiceResponse.data.id;

          // Transaction: FACTURACION
          await axios.post(`${apiDirectory}/set-invoice-transactions`,
            [{
              transaction_ident: '',
              invoice: this.invoice_id,
              amount: headerTotalStr, // exact header total
              reference: '',
              transaction_type: 1,
              transaction_date: new Date().toISOString(),
              origin_bank_account: '',
              destination_bank_account: '',
              bank: '',
              payment_method: '',
              cfdi_comments: '',
              observations: '',
            }]
          );

          // If PUE, create payment transaction as well (same exact amount)
          if (this.selectedNoteDetails[0].payment_method == "PUE") {
            await axios.post(`${apiDirectory}/set-invoice-transactions`,
              [{
                transaction_ident: '',
                invoice: this.invoice_id,
                amount: headerTotalStr,
                reference: '',
                transaction_type: 2,
                transaction_date: new Date().toISOString(),
                origin_bank_account: '',
                destination_bank_account: '',
                bank: '',
                payment_method: '',
                cfdi_comments: '',
                observations: '',
              }]
            );
          }

          const balanceNumber = await axios.post(`${apiDirectory}/calculate-invoice-balance`, { invoice_ident: this.invoice_id });
          const response = await axios.put(`${apiDirectory}/update-invoice/${this.invoiceNumber + '-' + this.invoiceSeries}/`, { balance: Number(balanceNumber.data) });

          if (response.data === "Success" || response.data.success) {
            await Swal.fire({
              title: '¡Actualizado!',
              text: 'Movimiento creado con éxito.',
              icon: 'success',
              confirmButtonText: 'Ok'
            });
          }

          await this.saveNotes(); // will compute per-note fields via allocation (matches header exactly)

          return stampedInvoice;

        } catch (error) {
          console.error('Error:', error);
          await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Hubo un problema al guardar la factura',
            confirmButtonText: 'Entendido'
          });
        }
      })
      .catch(error => {
        console.error('Error:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo obtener la información de facturación',
          confirmButtonText: 'Entendido'
        });
      });
  } catch (error) {
    console.error('Error:', error);
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: 'Ocurrió un error al preparar los datos de facturación',
      confirmButtonText: 'Entendido'
    });
  }
},
async invoiceStamping(billingInfo) {
  const apiDirectory = process.env.API_DIRECTORY;

  try {
    const response = await axios.post(`${apiDirectory}/invoice-stamping`, billingInfo);
    return response.data;
  } catch (error) {
    await Swal.fire({
      icon: 'error',
      title: 'Error de timbrado',
      text: error?.response?.data?.error || error.message || 'Ocurrió un error inesperado.',
      confirmButtonText: 'Entendido'
    });
    throw error;
  }
},
saveNotes: async function () {
  const apiDirectory = process.env.API_DIRECTORY;
  this.saving_note = true;

  // ---------- helpers ----------
  const toCents   = (n) => Math.round(Number(n) * 100);
  const fromCents = (c) => c / 100;
  const moneyNum  = (cents) => Number(fromCents(cents).toFixed(2));

  function allocateByWeights(weights, totalCents) {
    const sumW = weights.reduce((a, b) => a + b, 0);
    if (sumW === 0) return weights.map(() => 0);

    const exacts = weights.map(w => (w * totalCents) / sumW);
    const floors = exacts.map(x => Math.floor(x));
    let allocated = floors.reduce((a, b) => a + b, 0);
    let remaining = totalCents - allocated;

    const idxByRemainder = exacts
      .map((x, i) => ({ i, rem: x - Math.floor(x) }))
      .sort((a, b) => b.rem - a.rem)
      .map(o => o.i);

    for (let k = 0; k < remaining; k++) floors[idxByRemainder[k]] += 1;
    return floors;
  }

  try {
    // Per-note subtotals in cents
    const itemSubtotalCents = this.selectedNoteDetails.map(n => toCents(n.subtotal || 0));
    const grandSubtotalCents = itemSubtotalCents.reduce((a, b) => a + b, 0);

    const appliesRetention = !!this.clientInfo?.applies_retention;
    const retentionPerc = appliesRetention ? 0.04 : 0.00;

    // Header (target) amounts in cents
    const headerIvaCents       = Math.round(grandSubtotalCents * 0.16);
    const headerRetentionCents = Math.round(grandSubtotalCents * retentionPerc);

    // Allocate IVA and retention to notes proportionally to subtotal
    const ivaPerNoteCents = allocateByWeights(itemSubtotalCents, headerIvaCents);
    const retPerNoteCents = allocateByWeights(itemSubtotalCents, headerRetentionCents);

    // Persist every note with allocated values (no per-item rounding drift)
    await Promise.all(this.selectedNoteDetails.map(async (note, idx) => {
      try {
        const subtotalCents = itemSubtotalCents[idx];
        const ivaCents = ivaPerNoteCents[idx];
        const retCents = retPerNoteCents[idx];
        const totalCents = subtotalCents + ivaCents - retCents;

        // UI state
        note.iva = moneyNum(ivaCents);
        note.retention = moneyNum(retCents);
        note.total = moneyNum(totalCents);

        const updateData = {
          ...note,
          invoice: this.invoice_id,
          status: 6,
          iva: note.iva,
          retention: note.retention,
          total: note.total
        };

        await axios.put(`${apiDirectory}/notes/${note.note_ident}/`, updateData);
      } catch (error) {
        console.error(`Error updating note ${note.note_ident}:`, error);
        if (error.response?.status === 400) {
          throw new Error(`Nota ${note.note_ident}: Verifique que los datos que está ingresando son válidos.`);
        } else {
          throw new Error(`Nota ${note.note_ident}: Hubo un problema al actualizar los datos de la nota.`);
        }
      }
    }));

    await Swal.fire(
      '¡Actualizado!',
      `Se actualizaron ${this.selectedNoteDetails.length} notas con la factura ${this.invoiceNumber}.`,
      'success'
    );

  } catch (error) {
    console.error('Error in saveNotes:', error);
    await Swal.fire(
      'Error',
      error.message || 'Hubo un problema al actualizar las notas.',
      'error'
    );
  } finally {
    this.saving_note = false;
  }
},

      
          async generateInvoiceDocument(){
              if (!this.canGenerateInvoice) {
                  Swal.fire('Sin acceso', 'No tienes permisos para generar facturas.', 'warning')
                  return
              }
              this.saving_invoice = true;
              const apiDirectory = process.env.API_DIRECTORY;
              const response = await axios.post(`${apiDirectory}/calculate-invoice-number`);
              this.invoiceNumber = response.data[this.invoiceSeries] ?? 1;
              this.showPopup = false;
              
              // console.log(this.selectedNoteDetails);
              const firstNote = this.selectedNoteDetails[0];
              // console.log(firstNote) 
              const signedXML = await this.saveBilling();
              const vectorNoteID = firstNote['note_ident'].split('-');
              // const firstAssignation = this.assignationsData[0];
              // const dateDifferenceHours = Math.ceil(Math.abs(new Date(firstAssignation.end_time) - new Date(firstAssignation.start_time)) / (1000 * 60 * 60));
              axios.post(`${apiDirectory}/generate-invoice-documents`, 
                          {signedXML: signedXML,
                          // plh_authorize: this.localNoteDetails.approved_by,
                          plh_operatorName: 'VARIOS',
                          // plh_operatorNumber: firstAssignation.operator.employee_ident,
                          plh_orderId: 'VARIOS',
                          // plh_unitNumber: firstAssignation.unit.unit_short_id,
                          // plh_plates: this.localNoteDetails.vehicle_plates,
                          // plh_vehicleBrand: this.selectedBrandId + ' ' + this.selectedSubBrandId,
                          // plh_vehicleModel: this.localNoteDetails.vehicle_model + '  ' + this.localNoteDetails.vehicle_color,
                          // plh_niv: this.localNoteDetails.vehicle_engine_series,
                          // plh_insuredName: this.localNoteDetails.vehicle_owner_name,
                          // plh_record: this.localNoteDetails.file_number,
                          plh_insurancePolicy: 'VARIOS', //this.localNoteDetails.insurance_policy,
                          // plh_destination: this.localNoteDetails.destination.neighborhood + ', ' + this.localNoteDetails.destination.city + ' ' + this.localNoteDetails.destination.state,
                          // plh_origin: this.localNoteDetails.source.neighborhood + ', ' + this.localNoteDetails.source.city + ' ' + this.localNoteDetails.source.state,
                          // plh_maneuver: ' ',
                          // plh_startTime: firstAssignation.start_time,
                          // plh_arrivalTime: firstAssignation.arrival_time,
                          // plh_endTime: firstAssignation.end_time,
                          // plh_retention:this.localNoteDetails.retention,
                          plh_totalTime: '0.0', //dateDifferenceHours,
                          plh_discount: '0.00',
                          note_type: vectorNoteID[0],
                          invoice_number: this.invoiceNumber,
                          plh_series: this.invoiceSeries,
                          plh_maneuver: firstNote.maneuver_to_perform ?? '',
                          plh_serviceDescription: firstNote.source_notes ?? '',
                          }, 
                  {
                  responseType: 'blob'
              })
              .then(response => {
                  const url = window.URL.createObjectURL(new Blob([response.data]));
                  const link = document.createElement('a');
                  link.href = url;
                  link.setAttribute('download', `factura_${this.invoiceNumber}.zip`);
                  document.body.appendChild(link);
                  link.click();
                  link.remove();
                  this.saving_invoice = false;
                  Swal.fire({
                      title: '¡Actualizado!',
                      text: 'Se generó la factura',
                      icon: 'success',
                      showCancelButton: false, // Hide cancel button
                      confirmButtonText: 'Ok'
                  }).then((result) => {
                      if (result.isConfirmed) {
                          this.selectedNotes = [];
                          this.selectedNoteDetails = [];
                          this.queryOrders();
                          //location.reload(); // Reload the page after 'Ok' is clicked
                      }
                  });
              })
              .catch(error => {
                this.saving_invoice = false;
                  console.error('Error generating files', error)
              });
          },
      },

      mounted() {
        this.loadPermissions()
        if (!this.canAccessGroupedBilling) {
          Swal.fire('Sin acceso', 'No tienes permisos para facturación agrupada.', 'warning')
          this.$router.push({ path: '/main-panel' })
          return
        }
        this.fetchClients();
      }
  }
  </script>